<div class="modal-header">
    <h4 class="modal-title" id="cityDetailsModalLabel">{{ 'PROFILE.PREF.LOCATION_DETAILS_TITLE' | translate }}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div *ngIf="Object.keys(citiesMap)?.length > 0; else noCities" class="modal-body card flex flex-row flex-wrap p-3">
    <div class="cities-block col p-4" *ngFor="let key of Object.keys(citiesMap)">
      <div class="item-title bold">{{ key }}</div>
      <div *ngFor="let city of citiesMap[key]">
        {{ city }}
      </div>
    </div>
  </div>
  <ng-template #noCities>
    <div class="modal-body card p-3">
      <div class="no-cities pt-5 flex center">
        <h5 class="text-center">
          <span>{{ 'PROFILE.PREF.NO_CITIES' | translate }} </span>
          <div><a href="javascript: void(0);" (click)="navigateToProfile()">{{ 'PROFILE.PREF.NO_CITIES_UPDATE' | translate }}</a></div>
        </h5>
        <div class="anim text-center p-3">
          <ng-lottie class="anim-json" [options]="options"></ng-lottie>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal();">{{ 'GENERAL.OK' | translate }}</button>
  </div>